import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import StyledCheckbox from '../../common/styled/Checkbox';

export const buildElectiveColumns = (
  electiveNames: string[],
  onToggle: (studentId: string, subjectKey: string) => void,
  getValue: (row: any, subjectKey: string) => boolean,
  disabled?: boolean,
  unsavedChangesMap?: Record<string, Record<string, boolean>>
): GridColDef[] => {
  return [
    {
      field: 'studentName',
      headerName: 'Student Name',
      flex: 1,
      type: 'string'
    },
    {
      field: 'enrollmentNo',
      headerName: 'Enrollment No',
      flex: 1,
      type: 'string'
    },
    {
      field: 'rollNumber',
      headerName: 'Roll No',
      flex: 0.7,
      type: 'string'
    },
    ...electiveNames.map(
      (name): GridColDef => ({
        field: name,
        headerName: name.toUpperCase(),
        flex: 0.7,
        type: 'boolean',
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        filterable: false,
        cellClassName: (params) => {
          const studentId = params.row.studentId;
          return unsavedChangesMap?.[studentId]?.[name]
            ? 'elective-cell-changed'
            : '';
        },
        renderCell: (params: GridRenderCellParams) => {
          const assigned = getValue(params.row, name);
          return (
            <StyledCheckbox
              checked={!!assigned}
              disabled={disabled}
              size='small'
              onChange={() => onToggle(String(params.row.id), name)}
            />
          );
        }
      })
    )
  ];
};
